export default __webpack_public_path__ + "static/1523-e1c733aa4f609a2f35f100a69cc07a81.gif";